import { ReportScore } from "@/types/evaluate";
import { CheckIcon } from "lucide-react";
import { VersionScore } from "../VersionScore";

const EvaluationStatus = ({
  id,
  hasReportId,
  versionEvaluationScoresRegistry,
}: {
  id: number;
  hasReportId: boolean;
  versionEvaluationScoresRegistry: { [key: number]: ReportScore | null };
}) => {
  if (versionEvaluationScoresRegistry[id]) {
    return (
      <div className="ml-6 flex items-center justify-between">
        <div className="py-0.5 text-xs text-gray-600">
          <VersionScore score={versionEvaluationScoresRegistry[id]} />
        </div>
      </div>
    );
  }

  if (hasReportId && !versionEvaluationScoresRegistry[id]) {
    return (
      <div className="ml-6 flex items-center justify-between">
        <div className="py-0.5 text-xs text-gray-600">
          <div className="flex items-center justify-between">
            <CheckIcon
              className="mr-1 inline h-3.5 w-auto"
              aria-hidden="true"
            />
            <div className="text-xs">Evaluated</div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default EvaluationStatus;
